import { Icon } from "@chakra-ui/react";

export default function Climate(props) {
  return (
    <Icon
      width={["24px", null, "48px"]}
      height={["24px", null, "48px"]}
      viewBox="0 0 48 48"
      {...props}
    >
      <path
        d="M15.3507808,23 L23,23 L23,15.502797 L15.2144368,5.618782 C14.3893948,4.571365 15.9605198,3.333801 16.7855628,4.381218 L23,12.27064 L23,1 C23,0.447715 23.4477148,0 24,0 C24.5522848,0 25,0.447715 25,1 L25,12.27064 L31.2144368,4.381218 C31.5561808,3.947364 32.1849268,3.872693 32.6187818,4.214437 C33.0526358,4.556181 33.1273068,5.184927 32.7855628,5.618782 L25,15.502797 L25,23 L32.4972028,23 L42.3812178,15.214437 C43.4286348,14.389395 44.6661988,15.96052 43.6187818,16.785563 L35.7293598,23 L47,23 C48.3333328,23 48.3333328,25 47,25 L35.7293598,25 L43.6187818,31.214437 C44.6661988,32.03948 43.4286348,33.610605 42.3812178,32.785563 L32.4972028,25 L25,25 L25,32.649219 L32.7808688,42.375305 C33.6137958,43.416463 32.0520578,44.665853 31.2191307,43.624695 L25,35.850781 L25,47 C25,47.552285 24.5522848,48 24,48 C23.4477148,48 23,47.552285 23,47 L23,35.850781 L16.7808688,43.624695 C15.9479418,44.665853 14.3862038,43.416463 15.2191307,42.375305 L23,32.649219 L23,25 L15.3507808,25 L5.62469475,32.780869 C4.58353675,33.613796 3.33414675,32.052058 4.37530475,31.219131 L12.1492188,25 L1,25 C-0.33333325,25 -0.33333325,23 1,23 L12.1492188,23 L4.37530475,16.780869 C3.33414675,15.947942 4.58353675,14.386204 5.62469475,15.219131 L15.3507808,23 Z"
        id="Path"
        fill="currentColor"
        fillRule="nonzero"
      />
    </Icon>
  );
}
